import { apis } from "apis";
import ServiceBase from "./service-base";
import IHttpResponse from "src/http/http-response";
import { ServiceInjectable } from "src/utils/services";
import { ICheckupTypeModel, ICheckupItemModel } from "@/model";

/**
 * 商品项目类
 * @class
 * @version 1.0.0
 */
@ServiceInjectable()
export default class GoodsService extends ServiceBase {
    
    /**
     * 添加/删除商品类型
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async operationGoodsCategory(data: any): Promise<IHttpResponse>
     {
        let response;
        if(data.id)
        {
            response = await this.apis.editGoodsCategory({ data });
        }
        else
        {
            response = await this.apis.addGoodsCategory({ data });
        }
        
        return response;
    }

    /**
     * 获取商品分类分页
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getGoodsCategoryPage(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getGoodsCategoryPage({ data });
        return response;
    }

    /**
     * 获取商品分类列表
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getGoodsCategoryList(): Promise<IHttpResponse> {
        let response = await this.apis.getGoodsCategoryList({});
        return response;
    }

    /**
     * 删除商品类型
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async deleteGoodsCategory(id: number): Promise<IHttpResponse> {
        let response = await this.apis.deleteGoodsCategory({ urlPath: { id } });
        return response;
    }

    /**
     * 获取商品详情
     * @public
     * @returns {Promise<IHttpResponse>}
     */
    public async getGoodsCategoryDetail(data: any): Promise<IHttpResponse> {
        let response = await this.apis.getGoodsCategoryDetail({ data });
        return response;
    }

    /**
     * 添加/删除商品
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async operationGoods(data: any): Promise<IHttpResponse>
     {
        let response;
        if(data.id)
        {
            response = await this.apis.editGoods({ data });
        }
        else
        {
            response = await this.apis.addGoods({ data });
        }
        
        return response;
    }

    /**
     * 获取商品列表(不带价格)
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getGoodsPage(data: any): Promise<IHttpResponse>
     {
        let response = await this.apis.getGoodsPage({ data });
        return response;
    }
    // /api/goodsSPU/queryDIYGoods
    /**
     * 获取商品列表(带价格，店铺装修用到)
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getGoodsPricePage(data: any): Promise<IHttpResponse>
     {
        let response = await this.apis.getGoodsPricePage({ data });
        return response;
    }

    /**
     * 删除商品
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async deleteGoods(id: number): Promise<IHttpResponse>
     {
        let response = await this.apis.deleteGoods({
            urlPath: {id}
        });
        return response;
    }
    
    /**
     * 获取商品
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getGoodsDetail(id: number): Promise<IHttpResponse>
     {
        let response = await this.apis.getGoodsDetail({
            urlPath: {id}
        });
        return response;
    }

    /**
     * 上下架商品
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async onOffshelf(id: number): Promise<IHttpResponse>
     {
        let response = await this.apis.onOffshelf({
            urlPath: {id}
        });
        return response;
    }
    
    /**
     * 分销商品
     * @public
     * @returns {Promise<IHttpResponse>}
     */
     public async getDistributionGoods(data: any): Promise<IHttpResponse>
     {
        let response = await this.apis.getDistributionGoods({
            data: data
        });
        
        return response;
    }
    
}